import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid } from '@mui/material';
import { useContext } from 'react';
import { ProjectContext } from '../../ProjectRequestFrom';
import RequestPlanPreview from '../../RequestKth2/RequesPlanPreview/RequestPlanPreview';

const ModalPreview = () => {
    const {
        isModalPreview,
        setisModalPreview
    } = useContext(ProjectContext);


    return (
        <DialogPreview
            IsOpen={isModalPreview}
            IsBackdropClick={false}
            onClose={() => { setisModalPreview(false); }}
            JsxDialogAction
            CloseSave={false}
            Close={false}
            Color='white'
            Title={"ดูตัวอย่าง กท. 2"}
            fullScreen={true}
        >
            <Grid container justifyContent={"center"} >
                <Grid item xs={12} md={12} style={{ paddingBottom: '1%', }}>
                    <RequestPlanPreview />
                </Grid>

            </Grid>
        </DialogPreview >
    )
}

export default ModalPreview
